export const ACTIVITY_PHASES = [
  {
    id: "research",
    matches: ["research", "search", "read_public_url", "linked page"],
    title: "Researching current information",
    narration: "I’m gathering reliable information to use in the response.",
  },
  {
    id: "document",
    matches: ["sandbox", "creating content", "preparing final file", "writing"],
    title: "Preparing your requested file",
    narration: "I’m turning the findings into the requested deliverable.",
  },
  {
    id: "documents",
    matches: ["document", "uploaded file"],
    title: "Reviewing the provided material",
    narration:
      "I’m reading the available material before I use it in the response.",
  },
  {
    id: "integration",
    matches: ["composio", "connected app", "connection"],
    title: "Working with your connected services",
    narration:
      "I’m checking the available services and will pause if your approval is needed.",
  },
];
